import React from 'react';

const ClientLogos = () => {
  return (
    <div className="client-logos">
      {/* Untraceable SVG Logos */}
      <svg viewBox="0 0 100 30" className="client-logo">
        <path d="M10 15H30V25H10z" fill="#7c3aed" />
        <path d="M35 10L50 25L65 10" stroke="#ec4899" strokeWidth="2" fill="none" />
      </svg>
      
      <svg viewBox="0 0 100 30" className="client-logo">
        <circle cx="20" cy="15" r="10" fill="#10b981" />
        <rect x="40" y="5" width="30" height="20" rx="5" fill="#3b82f6" />
      </svg>
      
      <svg viewBox="0 0 100 30" className="client-logo">
        <polygon points="15,5 5,25 25,25" fill="#f59e0b" />
        <path d="M40 5L60 5L70 25L50 25Z" fill="#8b5cf6" />
      </svg>
      
      <svg viewBox="0 0 100 30" className="client-logo">
        <rect x="5" y="5" width="20" height="20" rx="3" fill="#ef4444" />
        <path d="M40 5Q55 15 40 25" stroke="#10b981" strokeWidth="3" fill="none" />
      </svg>
    </div>
  );
};

export default ClientLogos;
